import axios from "axios";

export default {
  state: () => ({
    requestors: [],
    loadingRequestors: false,
    errorLoadingRequestors: false,
    submittingRequest: false,
    errorSubmittingRequest: false,
    submittingRequestor: false,
    errorSubmittingRequestor: false,
    requestResponse: null
  }),
  mutations: {
    fetchedData(state, requestors) {
      state.requestors = requestors || [];
      if (requestors !== null) {
        state.errorLoadingRequests = false;
      }
    },
    submittingRequest(state, submittingFlag) {
      state.submittingRequest = submittingFlag || false;
    },
    errorSubmittingRequest(state, errorSubmittingFlag) {
      state.errorSubmittingRequest = errorSubmittingFlag || false;
    },
    loadingRequestors(state, loadingFlag) {
      state.loadingRequestors = loadingFlag || false;
    },
    errorLoadingRequestors(state, errorLoadingFlag) {
      state.errorLoadingRequestors = errorLoadingFlag || false;
    },
    submittingRequestor(state, submittingFlag) {
      state.submittingRequestor = submittingFlag || false;
    },
    errorSubmittingRequestor(state, errorSubmittingFlag) {
      state.errorSubmittingRequestor = errorSubmittingFlag || false;
    },
    setSubmitRequestResponse(state, response) {
      state.requestResponse = response.email[0] || response.phone[0] || null;
    },
    clearRequestResponse(state) {
      state.requestResponse = null;
    }
  },
  getters: {
    requestors: (state) => state.requestors,
    loadingRequestors: (state) => state.loadingRequestors,
    errorLoadingRequestors: (state) => state.errorLoadingRequestors,
    submittingRequestor: (state) => state.submittingRequestor,
    errorSubmittingRequestor: (state) => state.errorSubmittingRequestor,
    submittingRequest: (state) => state.submittingRequest,
    errorSubmittingRequest: (state) => state.errorSubmittingRequest,
    requestResponse: (state) => state.requestResponse,
  },
  actions: {
    getRequestors({ commit }) {
      const url = "/apis/app-catalog-api/requestors";
      commit("loadingRequestors", true);

      return axios
        .get(url)
        .then((response) => {
          commit("loadingRequestors", false);
          if (response.status !== 200) {
            commit("fetchedData", null);
            commit("errorLoadingRequestors", true);
            return;
          }
          commit("fetchedData", response.data);
        })
        .catch(() => {
          commit("loadingRequestors", false);
          commit("fetchedData", null);
          commit("errorLoadingRequestors", true);
        });
    },

    addRequestor({ commit }, payload) {
      const url = "/apis/app-catalog-api/requestors";
      commit("submittingRequestor", true);
      commit('clearRequestResponse')

      return axios
        .post(url, payload)
        .then((response) => {
          commit("submittingRequestor", false);
          if (response.status !== 200) {
            commit("errorSubmittingRequestor", true);
            return;
          }
          commit("errorSubmittingRequestor", false);
          commit("submittingRequestor", false);
        })
        .catch(e => {
          commit('setSubmitRequestResponse', e.response.data.data.errors)
          commit("submittingRequestor", false);
          commit("errorSubmittingRequestor", true);
        });
    },

    submitRequest({ commit }, payload) {
      const url = "/apis/app-catalog-api/requests";
      commit("submittingRequest", true);

      return axios
        .post(url, payload)
        .then((response) => {
          commit("submittingRequest", false);
          if (response.status !== 200) {
            commit("errorSubmittingRequest", true);
            return;
          }
          commit("errorSubmittingRequest", false);
          commit("submittingRequest", false);
        })
        .catch(() => {
          commit("submittingRequest", false);
          commit("errorSubmittingRequest", true);
        });
    },
  },
};
